import React from "react";
import { withRouter } from "react-router-dom";
import FormSignUp from "./FormSignUp";

const SignUp = ({ history }) => {
  return <FormSignUp history={history} />;
};

export default withRouter(SignUp);
